import ServiceMessage from '../../../../../pages/vip/features/service-message/new-budget-message';

export default ServiceMessage;
